import React from "react";
import styles from "../../styles/About.module.css";
import image from "../../assets/images/arya.jpg";

const About = () => {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.aboutWrapper}>
        <h1 className={styles.aboutTitle}>About Me</h1>

        <div className={styles.aboutTop}>
          <img src={image} alt="AI-Solutions" className={styles.aboutImage} />
          <div className={styles.aboutIntro}>
            <p>
              I am Arya Mainali, a certified Linux professional (RHCSA and RHCE)
              with a strong passion for DevOps and cloud-native technologies. I
              am actively expanding my expertise in Kubernetes, GitOps, Jenkins,
              and automation tools like Ansible. My goal is to design, deploy,
              and manage scalable, secure, and highly available systems,
              applying modern DevOps practices to real-world infrastructure
              challenges.
            </p>
          </div>
        </div>

        <div className={styles.aboutContent}>
          <p>
            With hands-on experience in Linux and AIX system administration,
            virtualization, and enterprise server management, I have a solid
            foundation for integrating development and operations workflows. I
            am skilled in configuring servers, automating deployments,
            monitoring systems, and maintaining robust IT environments, ensuring
            operational efficiency and reliability across diverse
            infrastructures.
          </p>

          <p>
            I am committed to continuous learning and professional growth,
            documenting my projects and exploring emerging technologies. My
            portfolio highlights my journey in DevOps, Kubernetes, and
            infrastructure automation, supported by RHCSA and RHCE
            certifications, reflecting my dedication to building efficient,
            future-ready, and highly optimized IT solutions.
          </p>
        </div>

        <div>
          <br />
          <br />
        </div>
        { /* 

        <div>
          <a href="/contact" className={styles.aboutCTA}>
            Contact Me
          </a> <br />
          <a href="/feedback" className={styles.aboutCTA}>
            Feedback
          </a>
        </div>

        */}

        <div className={styles.socialLinks}>
          <button aria-label="Facebook">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="24"
              height="24"
            >
              <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99h-2.54v-2.89h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.89h-2.34v6.99C18.34 21.12 22 16.99 22 12z" />
            </svg>
          </button>

          {/* <button aria-label="LinkedIn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="15"
              height="24"
            >
              <path d="M4.98 3.5C3.34 3.5 2 4.84 2 6.48c0 1.64 1.34 2.98 2.98 2.98s2.98-1.34 2.98-2.98c0-1.64-1.34-2.98-2.98-2.98zM2.4 8.95h5.15v12.55H2.4V8.95zm7.75 0h4.94v1.71h.07c.69-1.31 2.37-2.7 4.88-2.7 5.22 0 6.18 3.44 6.18 7.91v9.63h-5.15v-8.53c0-2.04-.04-4.65-2.84-4.65-2.84 0-3.27 2.21-3.27 4.49v8.69H10.1V8.95z" />
            </svg>
          </button> */}

          <button aria-label="Twitter">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="24"
              height="24"
            >
              <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.29 4.29 0 001.88-2.37 8.57 8.57 0 01-2.71 1.04 4.28 4.28 0 00-7.3 3.9A12.15 12.15 0 013 4.8a4.28 4.28 0 001.33 5.71 4.23 4.23 0 01-1.94-.54v.05a4.28 4.28 0 003.43 4.19 4.3 4.3 0 01-1.93.07 4.28 4.28 0 003.99 2.97 8.6 8.6 0 01-5.32 1.84c-.35 0-.7-.02-1.04-.06a12.14 12.14 0 006.57 1.93c7.88 0 12.2-6.53 12.2-12.2l-.01-.56A8.72 8.72 0 0024 4.56a8.48 8.48 0 01-2.54.7z" />
            </svg>
          </button>

          <button aria-label="Instagram">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="24"
              height="24"
            >
              <path d="M7.75 2h8.5C19.55 2 22 4.45 22 7.75v8.5C22 19.55 19.55 22 16.25 22h-8.5C4.45 22 2 19.55 2 16.25v-8.5C2 4.45 4.45 2 7.75 2zm0 1.5C5.68 3.5 4 5.18 4 7.25v8.5C4 18.32 5.68 20 7.75 20h8.5c2.07 0 3.75-1.68 3.75-3.75v-8.5C20 5.68 18.32 3.5 16.25 3.5h-8.5zm8.75 2a1 1 0 110 2 1 1 0 010-2zm-4.25 1.25a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 1.5a4 4 0 100 8 4 4 0 000-8z" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export { About };
